import React from 'react';
import { Modal, Button } from 'react-bootstrap';

interface DeleteConfirmationModalProps {
  show: boolean;
  handleClose: () => void;
  handleDelete: () => void | Promise<void>;
  itemName: string;
  id?: string | number;
}

const DeleteConfirmationModal: React.FC<DeleteConfirmationModalProps> = ({ 
  show, 
  handleClose, 
  handleDelete, 
  itemName, 
  id 
}) => {
  const handleDeleteClick = async (e: React.MouseEvent<HTMLButtonElement>): Promise<void> => {
    e.preventDefault();
    handleClose();
    await handleDelete();
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Delete Confirmation</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>Are you sure you want to delete {itemName}?</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="danger" onClick={handleDeleteClick}>
          Delete
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteConfirmationModal;

